(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
function updateArticleRecommendations(){document.querySelectorAll('[data-article-recommendations]').forEach(section=>{if(section.dataset.personalize!=='true')return;let game;try{game=sessionStorage.getItem('pb-game-preference');}catch{return;}const panel=[...section.querySelectorAll('[data-recommendation-game]')].find(p=>p.dataset.recommendationGame===game);if(!panel)return;section.querySelectorAll('[data-recommendation-game],[data-recommendation-default]').forEach(p=>p.hidden=p!==panel);});}
updateArticleRecommendations();document.addEventListener('shopify:section:load',updateArticleRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const install = (options) => {
    if (!options || typeof options.formatPrice !== 'function' || options.pbRoundedDisplay) return;
    const original = options.formatPrice;
    options.formatPrice = function (value) {
      let amount = Number(value || 0);
      if (!Number.isFinite(amount)) return original.call(this, value);
      const context = Object.create(this);
      if (window.Currency && this.baseCurrency !== this.currentCurrency) {
        amount = window.Currency.convert(amount, this.baseCurrency, this.currentCurrency);
        context.baseCurrency = this.currentCurrency;
      }
      const places = /amount_no_decimals/.test(this.moneyFormat) ? 0 : 2;
      const scale = 10 ** places;
      const scaled = Math.abs(amount) * scale;
      const rounded = Math.sign(amount) * Math.round(scaled + Number.EPSILON * Math.max(1, scaled) * 4) / scale;
      return original.call(context, rounded);
    };
    options.pbRoundedDisplay = true;
  };
  let attempts = 0;
  const timer = setInterval(() => {
    if (window.jQuery) {
      window.jQuery(window).off('dpo_before_initialize.pbRounding').on('dpo_before_initialize.pbRounding', (_event, options) => install(options));
      install(window.DynamicProductOptions);
      if (window.dpoOptions) {
        install(window.dpoOptions);
        if (window.dpoOptions.isInit) window.dpoOptions.updatePrice();
        clearInterval(timer);
      }
    }
    if (++attempts >= 200) clearInterval(timer);
  }, 100);
})();

  } catch(e) { console.error(e); }
})();
})();
